import type { ReactNode } from "react";

import {
  ColocaStatusPill,
  type ColocaStatusPillProps,
} from "@/shared/components/data-display/ColocaStatusPill";

interface EditEntityHeaderProps {
  /** Top-level description shown to the left of the badge. */
  description: ReactNode;
  /** Read-only badge label (e.g. "Individual" / "Empresa"). */
  typeBadgeLabel: string;
  /** Semantic pill variant for the entity type. Use `getTypeBadgeVariant` from `clientsTableHelpers`. */
  typeBadgeVariant: NonNullable<ColocaStatusPillProps["variant"]>;
}

/**
 * Description slot used inside the edit drawers (clients + organizations). Lays out the prose description and
 * a non-editable `type` badge rendered with the design-system `ColocaStatusPill`.
 */
export function EditEntityHeader({ description, typeBadgeLabel, typeBadgeVariant }: EditEntityHeaderProps) {
  return (
    <span className="flex items-start justify-between gap-2">
      <span className="flex-1">{description}</span>
      <ColocaStatusPill variant={typeBadgeVariant} size="sm" className="shrink-0">
        {typeBadgeLabel}
      </ColocaStatusPill>
    </span>
  );
}
